export const APP_SESSION_STORAGE_KEY = "app-session-uuid";
export const APP_SESSION_HEADER = "X-Hallow-App-Session";
